<template>
  <div class="classlist-cont">
    <div class="video-scroll-box">
      <div class="nav-tabs">
        <div
          v-for="(item, index) in rangeList"
          :key="index"
          @click="changeTab(item)"
          class="tab-item"
          :class="{'bg-cur':pageData.mediaType==item.parameter}"
        >{{ item.title }}</div>
      </div>
      <EmptyTip v-if="pageData.list.length == 0 && loadFinish" :emptyTip="$t('blendType.noVedio')" />
      <template v-else>
        <ScrollBox :list="pageData.list" @getData="getData">
          <div class="classlist-cont__box">
            <div
              v-for="(item, index) in pageData.list"
              @click="viewVideo(item)"
              :key="index"
              class="item"
            >
              <div class="img-box">
                <!-- ?x-oss-process=video/snapshot,t_15000,m_fast,w_500,h_500 -->
                <img :src="item.media_coverimg" alt />
              </div>
              <p>{{ item.media_name }}</p>
            </div>
          </div>
        </ScrollBox>
      </template>
    </div>
  </div>
</template>
<script>
import ScrollBox from "@/components/ScrollBox";
import VideoHttp from "../classroom";
import EmptyTip from "@/components/Empty";

export default {
  name: "video-home",
  data() {
    return {
      rangeList: [
        { title: this.$store.state.globalTxt.Club1?this.$store.state.globalTxt.Club1:this.$t('Common.kctvTwo'), parameter: "1" },
        { title: this.$store.state.globalTxt.Club2?this.$store.state.globalTxt.Club2:this.$t('Common.kctvOne'), parameter: "0" },
      ],
      canLoad: true,
      isLoading: false,
      loadFinish: false,

      showBookBox: false,
      videoDetail: null,
      isLove: false,

      pageData: {
        mediaType: 1,
        parameter: "",
        p: 1,
        num: 30,
        list: []
      }
    };
  },
  components: {
    ScrollBox,
    EmptyTip
  },
  created() {
    this.$emit("setReviewTitle", "KC TV");
    this.$store.dispatch("setLoadingStatus", true);
    this.student_id = this.$store.state.currentChild.student_id;
    this.classcode_branch = this.$store.state.currentChild.classcode_branch;
    this.getHourMedia();
  },
  methods: {
    changeTab(v) {
      this.loadFinish = false
      this.canLoad = true;
      this.isLoading = false;
      this.pageData.p = 1;
      this.pageData.list = [];
      this.pageData.mediaType = v.parameter
      this.getHourMedia();
    },
    // 视听资源->视频资源获取
    getHourMedia() {
      if (this.canLoad) {
        this.isLoading = true;
        this.$store.dispatch("setLoadingStatus", true);
        VideoHttp.getHourMedia({
          member_id: this.$store.state.member_id,
          token: this.$store.state.token,
          student_id: this.student_id,
          classcode_branch: this.classcode_branch,
          p: this.pageData.p,
          num: this.pageData.num,
          media_type: this.pageData.mediaType
        }).then(res => {
          const { error, result } = res.data;
          if (error == 0) {
            if (result.list.length < this.pageData.p) {
              this.canLoad = false;
            }
            this.pageData.list = this.pageData.list.concat(result.list);
          } else {
            this.canLoad = false;
            this.pageData.list = this.pageData.list.concat([]);
          }
          ++this.pageData.p;
          this.isLoading = false;
          this.loadFinish = true;
          this.$store.dispatch("setLoadingStatus", false);
        });
      }
    },
    getData() {
      console.log("getData");
      if (!this.isLoading && this.canLoad) {
        this.getHourMedia();
      }
    },
    viewVideo(item) {
      // this.getOneVideo(item.video_id);
      console.log(item);
      if (item.media_outurl) {
        window.open(`${item.media_html_url}`, "_blank");
      } else {
        this.$router.push({
          path: `/Classroom/ClassVideo?id=${item.media_id}&from=quket`
        });
      }
    }
  }
};
</script>
<style lang="less" scoped>
.classlist-cont {
  height: 100%;
  .nav-tabs {
    padding: 0 30px;
  }
  .classlist-cont__box {
    width: 765px;
    margin: 0 auto;
    padding: 0 0 15px;
    display: flex;
    flex-wrap: wrap;
    .item {
      width: 238px;
      margin-bottom: 15px;
      margin-right: 25px;
      background-color: #fff;
      border-radius: 6px;
      cursor: pointer;
      &:nth-child(3n) {
        margin-right: 0;
      }
      .img-box {
        height: 119px;
        width: 100%;
        overflow: hidden;
        border-radius: 10px;
        position: relative;
        img {
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate3d(-50%, -50%, 0);
          height: 100%;
        }
      }
      p {
        height: 56px;
        padding: 15px 10px;
        display: flex;
        font-size: 14px;
        align-items: center;
        // justify-content: flex-start;
        justify-content: center;
        border-radius: 0 0 10px 10px;
      }
    }
  }

  .video-scroll-box {
    height: calc(100% - 35px);

    .nav-tabs {
      width: 400px;
      margin: 0 auto;
    }
  }
  .height20 {
    height: 25px;
  }
  @media screen and (max-width: 780px) {
    .classlist-cont__box {
      width: 615px;
      .item {
        &:nth-child(4n) {
          margin-right: 0;
        }
        &:nth-child(5n) {
          margin-right: 25px;
        }
        p {
          height: 40px;
        }
      }
    }
  }
  @media screen and (min-width: 1350px) {
    .classlist-cont__box {
      width: 1028px;
      .item {
        &:nth-child(3n) {
          margin-right: 25px;
        }
        &:nth-child(4n) {
          margin-right: 0;
        }
      }
    }
  }
  @media screen and (min-width: 1500px) {
    .classlist-cont__box {
      width: 1290px;
      .item {
        &:nth-child(4n) {
          margin-right: 25px;
        }
        &:nth-child(5n) {
          margin-right: 0;
        }
      }
    }
  }
}

.video-pop-mask {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.7);
  z-index: 100;
  display: flex;
  align-items: center;
  justify-content: center;
  .video-pop-box {
    width: 566px;
    padding: 30px;
    display: flex;
    // height: 358px;
    background: rgba(255, 255, 255, 1);
    border-radius: 8px;
    position: relative;
    .video-pop-close {
      width: 20px;
      height: 20px;
      position: absolute;
      top: -35px;
      right: -35px;
      background: url(../../../../assets/images/close.png) center center
        no-repeat;
      background-size: cover;
      cursor: pointer;
      &:hover {
        opacity: 0.9;
      }
    }
    .book-box-lf {
      margin-right: 15px;
      .img-poster {
        width: 190px;
        height: 190px;
      }
      .title {
        margin-bottom: 10px;
        color: #181818;
        font-size: 18px;
        text-align: center;
      }
    }
    .book-box-rt {
      padding-top: 30px;
      .desc {
        font-size: 12px;
        color: rgba(51, 51, 51, 1);
        line-height: 16px;
      }

      .limit-time {
        margin-top: 20px;
        text-align: right;
        font-size: 12px;
        color: rgba(51, 51, 51, 1);
        line-height: 16px;
      }
    }
    .pop-box-btns {
      display: flex;
      padding: 70px 0 20px;
      align-items: center;
      justify-content: center;
      button {
        width: 125px;
        height: 38px;
        margin-right: 10px;
        border-radius: 19px;
        color: #fff;
        font-size: 14px;
        cursor: pointer;
        &:last-child {
          margin-right: 0;
        }
      }
      .love-btn {
        display: flex;
        align-items: center;
        justify-content: center;
        .love-icon {
          width: 16px;
          height: 13px;
          margin-right: 5px;
          background: url("../../../../assets/images/studyCenter/love-icon.png")
            no-repeat center center;
          background-size: 100% 100%;
        }
      }
    }
  }
}
</style>